/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import type { Equal, ExpectTrue } from '../types/validation'

/* TypeScript */
export type ReviewsApiProps = {
  technicalName?: Maybe<string>
  title: string
  subtitle?: Maybe<string>
  reviews_ids: string[]
}

/* Schemas */
export const ReviewsApiPropsSchema = z.object({
  technicalName: z.nullish(z.string()),
  title: z.string(),
  subtitle: z.nullish(z.string()),
  reviews_ids: z.array(z.string()),
})

/* Schemas validation */
type TestReviewsProps = ExpectTrue<
  Equal<ReviewsApiProps, z.infer<typeof ReviewsApiPropsSchema>>
>
